"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetFooterCopyright = () => {
  const classes = (0, _styles.useStyles)();
  const year = new Date().getFullYear();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
    className: classes.footerDivider
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: classes.copyrightText
  }, "Copyright \xA9 ", year, " SingularityNET All rights reserved."));
};
var _default = exports.default = SnetFooterCopyright;